export const UPSELL = 'upsell';
export const STANDARD = 'standard';
